<template>
  <div>
    <v-dialog v-model="dialogBi" width="100%">
      <v-card>
        <v-card-title> Biometric Status </v-card-title>
        <v-card-text>
          <v-data-table
            :headers="headers"
            :items="listBiometric"
            :options.sync="options"
            :server-items-length="totalBiometric"
            :loading="loading"
            loading-text="Loading... Please wait"
            :item-class="rowClass"
            class="d-print-table"
            :footer-props="{
              itemsPerPageOptions: [5, 10, 25, 50],
            }"
            sort-by="id"
            :style="{ padding: '10px' }"
            fixed-header
          >
            <template v-slot:item="{ item, index }">
              <tr
                :key="index"
                :style="{ cursor: 'pointer' }"
                :class="selectedRow == index ? 'indigo lighten-5' : ''"
                @click="selectRow(index)"
              >
                <td class="d-block d-sm-table-cell d-print-table-cell">
                  {{ (options.page - 1) * options.itemsPerPage + index + 1 }}
                </td>
                <td class="d-block d-sm-table-cell d-print-table-cell">
                  {{ item.brand }}
                </td>
                <td class="d-block d-sm-table-cell d-print-table-cell">
                  {{ item.model }}
                </td>
                <td class="d-block d-sm-table-cell d-print-table-cell">
                  {{ item.os }}
                </td>
                <td class="d-block d-sm-table-cell d-print-table-cell">
                  {{ item.status_name }}
                </td>
                <td class="d-block d-sm-table-cell d-print-table-cell">
                  {{ item.updated_at }}
                </td>
              </tr>
            </template>
          </v-data-table>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { date } from '../../lib/helpers';

export default {
  props: ['dialog', 'id'],
  data() {
    return {
      selectedRow: '',
      options: {},
      headers: [
        {
          text: 'No',
          align: 'start',
          value: 'id',
          sortable: false,
          width: '10',
        },
        {
          text: 'Device Brand',
          value: 'brand',
          sortable: false,
          width: '150',
        },
        {
          text: 'Device Type',
          value: 'model',
          sortable: false,
        },
        {
          text: 'OS',
          value: 'os',
          sortable: false,
        },
        {
          text: 'Status',
          value: 'status_name',
          sortable: false,
        },
        {
          text: 'Last Update',
          value: 'updated_at',
          sortable: false,
        },
      ],
    };
  },
  watch: {
    options: {
      handler() {
        this.getDetailData();
      },
      deep: true,
    },
    dialogBi(val) {
      if (val == 1 && this.options.page) {
        this.getDetailData();
      }
    },
  },
  computed: {
    listBiometric() {
      return this.$store.state.merchantManagement.BioDetailList;
    },
    totalBiometric() {
      return this.$store.state.merchantManagement.BioTotalList;
    },
    totalPage() {
      return this.$store.state.merchantManagement.BioTotalPage;
    },
    loading() {
      return this.$store.state.merchantManagement.loading;
    },
    dialogBi: {
      set(val) {
        if (!val) {
          this.$emit('closeCancelParent');
        }
      },
      get() {
        return this.dialog;
      },
    },
  },
  methods: {
    selectRow(index) {
      if (this.selectedRow != index) {
        this.selectedRow = index;
      } else {
        this.selectedRow = '';
      }
    },

    rowClass() {
      const rowClass = 'max-width-col';
      return rowClass;
    },

    async getDetailData() {
      const { page, itemsPerPage } = this.options;

      await this.$store
        .dispatch('merchantManagement/viewBiometricStatus', {
          id: this.id,
          page,
          itemsPerPage,
          date,
        })
        .then(() => {
          if (this.totalPage < page) {
            if (this.totalPage == 0) {
              this.options.page = 1;
            } else {
              this.options.page = this.totalPage;
            }
          }
        });
    },
  },
};
</script>
